export enum EmailItemType {
  SubmissionOutbound = 'SubmissionOutbound',
  SubmissionInbound = 'SubmissionInbound',
  UnassignedInbound = 'UnassignedInbound',
  SubmissionInboundFromUser = 'SubmissionInboundFromUser',
}

export const isOutboundType = (type: EmailItemType) =>
  [EmailItemType.SubmissionOutbound, EmailItemType.SubmissionInboundFromUser].includes(type);
